import { restfulClient, actionClient } from '@/api'

const lemonMusicCode = '/lemon-music-code'

export const lemonMusicCodeApi = params => restfulClient.getCollection(lemonMusicCode, {...params,sorts:{id:'asc'}})


